module.exports = __webpack_public_path__ + "img/web-developer-preview.a0236800.jpg";